import React from "react";
import ContactDisplay from "../components/ContactDisplay/ContactDisplay";
import styles from "./page.default.module.css";
import { useTranslation } from "react-i18next";

const Contact: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.pageSection}>
      <div className={styles.container}>
        <div className={styles.heading}>
          <h1 className={styles.title}>{t("contactDisplay.title")}</h1>
          <p className={styles.description}>
            {t("contactDisplay.description")}
          </p>
        </div>
        <ContactDisplay />
      </div>
    </section>
  );
};

export default Contact;
